var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.close_status)?_c('div',{staticClass:"basic_floating_frame_index module",style:(Object.assign({}, _vm.background_style,
      _vm.position_style,
      {width: (_vm.width + "px"),
      height: (_vm.height + "px")},
      _vm.box_show)),on:{"dblclick":function($event){$event.stopPropagation();return _vm.edit_module($event)}}},[_c('div',{staticClass:"tooptipPart tooptipPart_to_top"},[_c('my_edit_btn',{attrs:{"module":_vm.module,"title":_vm.$t('widgets_basic_article_classification_index_336')}}),_vm._v(" "),_c('span',{staticClass:"sys_icon el-icon-view",attrs:{"title":_vm.$t('view_back_top_index_105')},on:{"click":_vm.hiddeFloatingFrame}})],1),_vm._v(" "),_c('i',{staticClass:" close-icon",style:({
      fontSize: _vm.closeBtnFontSize,
      width: _vm.closeBtnFontSize,
      height: _vm.closeBtnFontSize,
      lineHeight: _vm.closeBtnFontSize,
    }),on:{"click":_vm.frameClose}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticClass:"frame-text",domProps:{"innerHTML":_vm._s(_vm.listArr.content)}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae42a34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/basic_floating_frame/index.vue
// module id = null
// module chunks = 